"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, useContext, useMemo } from "react";
import { type UseRainforestPayinSessionArgs, useRainforestPayinSession } from "@/components/rainforest/use-rainforest-payin-session";
import { DebitOrCredit } from "@/types/enums/payment";
import { BookingFeePayinResponse } from "@/types/rainforest";
import { CreatePurchasePayinConfigResponse } from "@/types/shop";

/** Union of every payin-config response shape the provider can hold. */
export type PayinConfigResponse = BookingFeePayinResponse | CreatePurchasePayinConfigResponse;
interface RainforestPayinSessionContextValue {
  payinResponse: PayinConfigResponse | null;
  setDebitOrCredit: (debitOrCredit: DebitOrCredit) => void;
  isLoadingSession: boolean;
  isError: boolean;
}
const RainforestPayinSessionContext = createContext<RainforestPayinSessionContextValue | null>(null);
interface RainforestPayinSessionProviderProps<TInput, TResult extends PayinConfigResponse> extends UseRainforestPayinSessionArgs<TInput, TResult> {
  children: ReactNode;
}
export function RainforestPayinSessionProvider(t0) {
  const $ = _c(11);
  let children;
  let hookArgs;
  if ($[0] !== t0) {
    ({
      children,
      ...hookArgs
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = hookArgs;
  } else {
    children = $[1];
    hookArgs = $[2];
  }
  const {
    payinResponse,
    setDebitOrCredit,
    isLoadingSession,
    isError
  } = useRainforestPayinSession(hookArgs);
  let t1;
  if ($[3] !== isError || $[4] !== isLoadingSession || $[5] !== payinResponse || $[6] !== setDebitOrCredit) {
    t1 = {
      payinResponse,
      setDebitOrCredit,
      isLoadingSession,
      isError
    };
    $[3] = isError;
    $[4] = isLoadingSession;
    $[5] = payinResponse;
    $[6] = setDebitOrCredit;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const value = t1;
  let t2;
  if ($[8] !== children || $[9] !== value) {
    t2 = <RainforestPayinSessionContext.Provider value={value}>{children}</RainforestPayinSessionContext.Provider>;
    $[8] = children;
    $[9] = value;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}

/** Used by `PaymentMethodPicker` for BIN lookup and the hosted card iframe. */
export function useRainforestPayinSessionContext() {
  const value = useContext(RainforestPayinSessionContext);
  if (!value) {
    throw new Error("useRainforestPayinSessionContext must be used within RainforestPayinSessionProvider");
  }
  return value;
}